import axios from 'axios'
import { gettoken } from './api'

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})
// request
service.interceptors.request.use(
    config => {
        if (sessionStorage.getItem('token')) {
            config.headers['token'] = sessionStorage.getItem('token')
        }
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response
        if (res.data.error_code !== 200) {
            if (res.data.error_code === 202) {
                gettoken(res => {
                    sessionStorage.setItem('token', res.data.data)
                })
            }
            return Promise.reject(res.message || 'Error')
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js